import React, { useContext, useEffect, useState } from "react";
import { RootContext } from "../context/beltContext";
import { attributes } from "../components/cart/product-attributes";
import { getPrice } from "./pricingUtil";
import { formatSkus } from "../utils/cart-utils";
import { PromoContext } from "../context/promoContext";

const ChangeQuantity = (itemSku, fromCart = false, fromSavedCart = false) => {
    let [quantity, setQuantity] = useState(0);
    let [total, setTotal] = useState(0)
    let { skus, updateSkus } = useContext(RootContext)
    let { promos, activeCode } = useContext(PromoContext)
    let currentTotal;
    let finalCost;

    useEffect(() => { }, [total, quantity])
    useEffect(() => {
        if (itemSku === undefined) return;
        if (skus[itemSku] && (skus[itemSku]['price'] !== undefined)) {
            setQuantity(skus[itemSku].quantity);
            setTotal(skus[itemSku]['price']['totalCost']);
        }
    }, [skus, itemSku])

    function calcPromo(skuObj, sku){
        let obj = {...skuObj};
        if(!!activeCode && !!promos && promos.length){
            let promoObj = promos.find(promo => promo.code === activeCode);
            if(!promoObj.skus.includes(sku)) return skuObj;
            let discount = promoObj.discount;
            if(sku === 'ssuaan'){
                obj.price = {...obj.price, ...{ finalCost: obj.price.finalCost - ((discount * 12) * 100)} }
            } else {
                obj.price = {...obj.price, ...{ finalCost: obj.price.finalCost - (discount * 100)} }
            }
            obj.price = {...obj.price, ...{ totalCost: obj.price.finalCost} }
            return obj;
        } else {
            return skuObj;
        }
    }

    function updateSku(sku) {
        if (!skus[sku] || !skus[sku]['price']) return;
        setQuantity(skus[sku].quantity)
        setTotal(skus[sku]['price']['totalCost'])
        currentTotal = ['price']['totalCost'];
    }

    function getQuantity(qty) {
        setQuantity(qty);
    }

    function getTotal(result) {
        if (!!result) {
            currentTotal = result.totalCost;
            finalCost = result.finalCost;
        }
        setTotal(result);
    }

    const decreaseNum = async (sku) => {
        if (quantity === 0 || !skus[sku]) return `$0.00`;
        let update = { ...skus };
        let newPrice = await getPrice(update[sku].quantity - 1, sku, getTotal);
        update[sku] = {
            quantity: update[sku].quantity - 1,
            price: { totalCost: currentTotal, finalCost }
        };
        update[sku] = calcPromo(update[sku], sku);
        updateSkus(update)
        setQuantity(update[sku].quantity)
        if (!!fromCart) {
            updateCart(update, sku, 'cart')
        }
        if (!!fromSavedCart) {
            updateCart(update, sku, 'saved')
        }
        if(currentTotal === 0) return `$0.00`
        return formatTotal(currentTotal);
    }

    const increaseNum = async (sku) => {
        let update = { ...skus };
        let newPrice;
        if (!update[sku]) {
            newPrice = await getPrice(1, sku, getTotal)
            update[sku] = { quantity: 1, price: { totalCost: currentTotal, finalCost: !!finalCost && finalCost > 0 ? finalCost : currentTotal } };
            update[sku] = calcPromo(update[sku], sku);
        } else {
            newPrice = await getPrice(update[sku].quantity + 1, sku, getTotal)
            update[sku] = {
                quantity: update[sku].quantity + 1,
                price: { totalCost: currentTotal, finalCost }
            };
            update[sku] = calcPromo(update[sku], sku);
        }
        updateSkus(update, sku)
        setQuantity(update[sku].quantity)
        if (!!fromCart) {
            updateCart(update, sku, 'cart')
        }
        if (!!fromSavedCart) {
            updateCart(update, sku, 'saved')
        }
        return formatTotal(currentTotal);
    }

    const updateCart = (update, sku, storage) => {
        let old = window.localStorage.getItem(storage);
        let cart = JSON.parse(old)
        if (cart[sku]) {
            cart[sku].qty = update[sku].quantity
            cart[sku].price = { 
                totalCost: update[sku]['price']['totalCost'], 
                finalCost: update[sku]['price']['finalCost'] 
            }
            cart[sku].formattedTotal = formatTotal(update[sku]['price']['totalCost'])
            window.localStorage.setItem(storage, JSON.stringify(cart))
        }
    }

    const updateNum = async (sku, event) => {
        let val = Number(event.target.value);
        if (typeof val === undefined) return;
        if(val === 0){
            let update = { ...skus }
            update[sku] = {
                quantity: 0,
                price: { totalCost: 0, finalCost: 0 }
            }
            updateSkus(update)
            setQuantity(0)
        }
        let update = { ...skus }
        let newPrice = await getPrice(val, sku, getTotal)
        update[sku] = {
            quantity: val,
            price: { totalCost: currentTotal, finalCost }
        }
        update[sku] = calcPromo(update[sku], sku);
        updateSkus(update)
        setQuantity(update[sku].quantity)
        if (!!fromCart) {
            updateCart(update, sku, 'cart')
        }
        return formatTotal(currentTotal);
    }

    function formatTotal(currentTotal) {
        let t = currentTotal !== undefined ? currentTotal : total
        console.log('t: ', t, currentTotal, total)
        if (!t) return `$0.00`
        let str = t.toString()
        let price = str.substring(0, str.length - 2)
        return `$${price.toLocaleString()}.00`
    }

    const addToCart = (sku, title, cb = null) => {
        if (!skus[sku]) return;
        if (skus[sku].quantity === 0) {
            let newSkus = { ...skus };
            delete newSkus[sku];
            updateSkus(newSkus)
        }
        let item = {
            qty: skus[sku].quantity,
            price: { totalCost: skus[sku]['price']['totalCost'], finalCost: skus[sku]['price']['finalCost'] },
            formattedTotal: formatTotal(skus[sku]['price']['totalCost']),
            sku: sku,
            name: title,
            isMonthly: attributes[sku].isMonthly,
            billed: attributes[sku].billing
        }
        let old = window.localStorage.getItem('cart');
        let cart = JSON.parse(old)
        if (!cart) {
            cart = { [sku]: item }
        } else {
            cart[sku] = item;
        }
        window.localStorage.setItem('cart', JSON.stringify(cart))
        updateSkus(formatSkus(cart))
        if(cb){ cb(true) }
    }

    return {
        quantity,
        total,
        updateSku,
        setQuantity,
        updateNum,
        increaseNum,
        decreaseNum,
        addToCart,
        formatTotal,
        getQuantity
    };
}

export default ChangeQuantity;